/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteMemberCategoryInternalV2MembersCategoriesIdDelete$Params {
  id: string;
  org: string;
}

export function deleteMemberCategoryInternalV2MembersCategoriesIdDelete(http: HttpClient, rootUrl: string, params: DeleteMemberCategoryInternalV2MembersCategoriesIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteMemberCategoryInternalV2MembersCategoriesIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteMemberCategoryInternalV2MembersCategoriesIdDelete.PATH = '/_internal/v2/members/categories/{id}';
